export const ROW_TYPES = {
  LOAD_MORE: 'load_more',
  FULL_COLSPAN: 'full_colspan'
};
